// this file gets replaced with the real value during the build
const Version = '5.12.0';

export { Version as default };
